// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Concentrators_container__hnXFt {
  animation: Concentrators_init__D2YId 0.5s;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO {
  width: 90%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_searchBar__BwuUp {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_titleConcentrators__gNikP {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Concentrators_container__hnXFt .Concentrators_header__o34qO .Concentrators_titleConcentrators__gNikP .Concentrators_title__PNcgv {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin: 0;
  margin-left: 10px;
}
.Concentrators_filterButton__qT1fk {
  animation: Concentrators_init3__V-wW0 0.5s both;
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.Concentrators_filterButton__qT1fk p {
  text-transform: capitalize;
  margin-left: 5px;
  font-weight: 400;
}

.Concentrators_insertPaginate__kX4NT {
  width: 40px;
  height: 40px;
}

.Concentrators_insertPaginateButton__3lTkk {
  width: 30px;
  height: 30px;
}

.Concentrators_container__hnXFt .Concentrators_tableContainer__IEh1b {
  width: 90%;
  min-height: 300px;
}

.Concentrators_container__hnXFt .Concentrators_tableContainer__IEh1b .Concentrators_table__VHSJa {
  width: 100%;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Concentrators_pagination__xLuvs {
  scale: 1;
  margin-top: 40px;
  margin-bottom: 10px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@keyframes Concentrators_init__D2YId {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Concentrators/Concentrators.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAoB;EACpB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,+CAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.container .header {\n  width: 90%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.container .header .searchBar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .titleConcentrators {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleConcentrators .title {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin: 0;\n  margin-left: 10px;\n}\n.filterButton {\n  animation: init3 0.5s both;\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.filterButton p {\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.insertPaginate {\n  width: 40px;\n  height: 40px;\n}\n\n.insertPaginateButton {\n  width: 30px;\n  height: 30px;\n}\n\n.container .tableContainer {\n  width: 90%;\n  min-height: 300px;\n}\n\n.container .tableContainer .table {\n  width: 100%;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.pagination {\n  scale: 1;\n  margin-top: 40px;\n  margin-bottom: 10px;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Concentrators_container__hnXFt`,
	"init": `Concentrators_init__D2YId`,
	"header": `Concentrators_header__o34qO`,
	"searchBar": `Concentrators_searchBar__BwuUp`,
	"titleConcentrators": `Concentrators_titleConcentrators__gNikP`,
	"title": `Concentrators_title__PNcgv`,
	"filterButton": `Concentrators_filterButton__qT1fk`,
	"init3": `Concentrators_init3__V-wW0`,
	"insertPaginate": `Concentrators_insertPaginate__kX4NT`,
	"insertPaginateButton": `Concentrators_insertPaginateButton__3lTkk`,
	"tableContainer": `Concentrators_tableContainer__IEh1b`,
	"table": `Concentrators_table__VHSJa`,
	"pagination": `Concentrators_pagination__xLuvs`
};
export default ___CSS_LOADER_EXPORT___;
